import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Breadcrumbs::Item @route=\"discover.registry.box.versions\" @text={{t \"vagrant.subnav.discover.box.versions\"}} />\n{{outlet}}", {
  moduleName: "vagrant/templates/discover/registry/box/versions.hbs"
});